import { Routes } from '@angular/router';
import { NotFoundPageComponent } from './framework/components/not-found/not-found-page.component';
import { AuthGuard } from './guards/auth.guard';
import { environment } from 'src/environments/environment';
import { provideLoginRoutes } from 'login';
import { NoAccessComponent } from './framework/pages/no-access/no-access.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'app' },
  {
    path: 'app',
    canActivate: [AuthGuard.canLoadApp],
    loadChildren: () => import('./framework/framework.routes').then((m) => m.routes),
  },
];

// Add login routes dynamically if `loginHost` is not defined in the environment.
if (!environment.loginHost) {
  routes.push(...provideLoginRoutes({ loginHost: environment.loginHost }));
}

// Catch-all route for 404
routes.push({
  path: 'no-access',
  component: NoAccessComponent,
  canActivate: [AuthGuard.noAccessGuard]
}, {
  path: '**',
  component: NotFoundPageComponent,
  title: 'Active F - Page Not Found',
});

export default routes;
